import {
  ACCOUNT_PURPOSE_OPTIONS,
  BANK_ACCOUNT_DETAILS_STATUS_REASONS
} from '../BankAccountDetails/constants'
import { BANK_ACCOUNT_STATUS } from '../BankAccountsTable/constants'

export const isInStatuses = (inStatuses: BANK_ACCOUNT_STATUS[]) => ({
  status: {
    $in: inStatuses
  }
})

export const isInPurposes = (inPurposes: ACCOUNT_PURPOSE_OPTIONS[]) => ({
  purpose: {
    $in: inPurposes
  }
})

export const isNotDefault = () => ({
  is_default: {
    $ne: true
  }
})

export const isInReasons = (
  inReasons: BANK_ACCOUNT_DETAILS_STATUS_REASONS[]
) => ({
  status_reason: {
    $in: inReasons
  }
})

export const isNotInReasons = (
  inReasons: BANK_ACCOUNT_DETAILS_STATUS_REASONS[]
) => ({
  status_reason: {
    $nin: inReasons
  }
})
